import { render } from "./ArrowLeft.vue?vue&type=template&id=574332dc"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ArrowLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "574332dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('574332dc', __exports__)) {
    api.reload('574332dc', __exports__)
  }
  
  module.hot.accept("./ArrowLeft.vue?vue&type=template&id=574332dc", () => {
    api.rerender('574332dc', render)
  })

}


export default __exports__